export interface WebGpuSupport {
  supported: boolean;
  reason?: string;
}

/** Whether this browser exposes a WebGPU adapter (no fallback rendering). */
export function getWebGpuSupport(gpu: GPU | undefined): WebGpuSupport {
  if (gpu === undefined) {
    return {
      supported: false,
      reason: "WebGPU is not available in this browser.",
    };
  }
  return { supported: true };
}
